import { createFileRoute } from "@tanstack/react-router"
import { ResourceTypeDetailPage } from "@/components/rema/resource-types/ResourceTypeDetailPage"

function ResourceTypeDetailRoute() {
  const { resourceTypeNumber } = Route.useParams()
  return (
    <div className="p-6">
      <ResourceTypeDetailPage resourceTypeNumber={resourceTypeNumber} />
    </div>
  )
}

export const Route = createFileRoute("/rema/resource-types/$resourceTypeNumber")({
  staticData: {
    title: 'Resource Type Detail',
    isSecured: true,
  },
  component: ResourceTypeDetailRoute,
})
